import React from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";

const Pagination = ({ currentPage, setCurrentPage, getRollingReserveData, token, pagesData }) => {
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getRollingReserveData(token, newPage);
  };

  return (
    <div className="page-main">
      <div className="page-section">
        <div className="pagination">
          <button
            className="greyButton"
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            <FaLessThan />
          </button>
          <span className="pagination-button">{currentPage}</span>
          <button
            className="greyButton"
            disabled={currentPage >= pagesData} // Disable when last page is reached
            onClick={() => handlePageChange(currentPage + 1)}
          >
            <FaGreaterThan />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;